import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

import { useDoExerciseProgressContext } from '../../../../shared-components/Exercise/DoExerciseProgressContext';
import { ExerciseDoTestActions } from '../../../../shared-components/Exercise/ExerciseDoTestActions';
import { useExerciseProgress } from '../../../../shared-components/Exercise/useSaveExcerciseProgress';
import { useExerciseShortAnswerDoTestStore } from '../../store/exercise-short-answer-do-test.store';

const Main = styled.div`
  margin-top: 8px;
`;

export const DoTestActions = observer(({ element }: RenderElementProps) => {
  const { isLoginRequired } = element;
  const store = useExerciseShortAnswerDoTestStore();
  const save = useExerciseProgress();
  const { pageId } = useDoExerciseProgressContext();

  const check = () => {
    store.check();
    store.viewResult();
    save.mutate({ ...store.preparePayload(), pageId });
  };

  return (
    <Main className="short-answer-do-test-action">
      <ExerciseDoTestActions
        isLoginRequired={isLoginRequired}
        check={check}
        retry={() => store?.retry()}
        isViewResult={store?.isViewResult}
        lastResult={store?.resultSummary}
        retryCount={store?.retryCount}
      />
    </Main>
  );
});
